module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Page d'accueil !\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42206899"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 111
// module chunks = 0